import { Group, Text } from '@mantine/core';
import IdText from '@/components/common/IdText';

interface InfoRowProps {
  readonly label: string;
  readonly value?: string;
  /** Машинный идентификатор (ИНН, КПП, ОГРН, коды): значение — через IdText. */
  readonly mono?: boolean;
}

// Строка «подпись — значение» в блоках реквизитов и профиля. Пустое значение не показываем.
export default function InfoRow({ label, value, mono }: InfoRowProps) {
  if (!value) {
    return null;
  }
  return (
    <Group justify="space-between" wrap="nowrap" gap="md">
      <Text c="gray.7" size="sm">
        {label}
      </Text>
      <Text size="sm" ta="right" fw={500}>
        {mono ? <IdText>{value}</IdText> : value}
      </Text>
    </Group>
  );
}
